import type { CommonStylesPalette } from '../types.d';

export const getPhoneFrameStyle = (palette: CommonStylesPalette) => ({
  outerFrame: {
    border: `5px solid ${palette.neutralSecondary}`,
    borderBottom: 'none',
    borderRadius: '40px 40px 0 0',
    position: 'relative',
  },

  innerFrame: {
    border: `1px solid ${palette.neutralSecondary}`,
    borderBottom: 'none',
    borderRadius: 0,
    margin: '45px 15px 0 15px',
    paddingBottom: 1,

    '&:before': {
      content: '""',
      border: `5px solid ${palette.neutralSecondary}`,
      borderRadius: 5,
      left: '50%',
      top: 20,
      position: 'absolute',
    },
  },
});
